/**
 * util.ts中放的都是纯函数
 * 无副作用(DOM操作等)
 */
import Cookies from 'js-cookie';
import monitor from '@baidu/fe-monitor';
import {isErniebot} from './components/App/util';
import {PASSPORT_TIP, UC_TIP, LoginType, ABTestUserType} from './constants';

export function getQuery(name: string) {
    const parts = location.search.slice(1).split('&');
    for (const part of parts) {
        if (part.startsWith(name + '=')) {
            return part.slice(name.length + 1);
        }
    }
    return null;
}
export function getSearch(href: string) {
    const index = href.indexOf('?');
    return index < 0 ? '' : href.slice(index + 1);
}
export function getQueryVariable(name: string, query = getSearch(location.href)) {
    const parts = query.split('&');
    for (const part of parts) {
        if (part.startsWith(name + '=')) {
            return part.slice(name.length + 1);
        }
    }
    return null;
}

export function unescapeHTML(s: string) {
    return s.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&');
}

export function getRedirectUrl(url: string) {
    const redirectUrl = unescapeHTML(url);
    return encodeURIComponent(redirectUrl);
}

export function isMultiLogin() {
    const multiLogin = getQuery('multiLogin');
    if (multiLogin === '0' || multiLogin === 'false') {
        return false;
    }
    return true;
}

export function getLoginType() {
    if (!isMultiLogin() || /\blogin_type=uc\b/.test(location.search)) {
        return LoginType.UC;
    }
    if (isErniebot()) {
        return LoginType.SMS_PASSPORT;
    }
    return Cookies.get('default_ui_login_type') || LoginType.SMS_PASSPORT;
}

export function generateRandomUserName(name: string) {
    const allCharset = '0123456789';
    const length = (new Date().getMilliseconds() % 3) + 1;
    let value = name;
    for (let i = 0, n = allCharset.length; i < length; ++i) {
        value += allCharset.charAt(Math.floor(Math.random() * n));
    }
    return value;
}

export function isLoadByIframe() {
    return window.self !== window.top;
}

export const isMobile = () => screen.width <= 768;

export function getLoginTip() {
    const loginType = getLoginType();
    return loginType === 'uc' ? UC_TIP : PASSPORT_TIP;
}

export function getLinkFromQuery(
    base: string,
    // redirect 最后放在最后，因为redirect可能是带hash的
    queryKeys: string[] = ['mobile', 'email', 'multiLogin', 'from', 'needQualify', 'ambassadorId', 'redirect']
) {
    let query = '';
    for (const key of queryKeys) {
        const value = getQuery(key);
        if (value) {
            query += '&' + key + '=' + value;
        }
    }
    return base + query + location.hash;
}

export function getRegisterUcLink(timeStamp: string) {
    const registerUcLink = '/new-reg?_=' + timeStamp;
    return getLinkFromQuery(registerUcLink);
}

export function getEnv() {
    return location.href.includes('bce.baidu.com') ? 'ONLINE' : 'SANDBOX';
}

// js-cookie会默认urlencode一次，但是约定某些key例如redirect已经是encode过的，所以用自定义的converter，不做encode处理
export const rawCookies = Cookies.withConverter({
    write(value): any {
        return value;
    },
});

export function getInitParams(inputData: any): {
    staticPage: string;
    fromu: string;
    fromUrl: string;
    registerUcLink: string;
    redirectUrl: string;
    subuserLoginLink: string;
    error: string;
    cookieDomain: string;
} {
    const {error, cookieDomain, fromUrl, timeStamp} = inputData;

    const k = location.protocol + '//' + location.host;
    const staticPage = k + '/v3Jump.html';
    const search = getSearch(location.href);
    const fromuUrl = getQueryVariable('fromu', search);
    const from = getQueryVariable('from', search);
    const needQualify = getQueryVariable('needQualify', search);
    const ambassadorId = getQueryVariable('ambassadorId', search);
    const redirectUrl = (fromuUrl || getRedirectUrl(fromUrl)) + location.hash;
    const subuserRedirectUrl = (fromuUrl || getRedirectUrl(fromUrl)) + encodeURIComponent(location.hash);
    const subuserLoginLink = `${
        subuserRedirectUrl && !isLoadByIframe() ? `/login?redirect=${subuserRedirectUrl}` : '/login'
    }`;

    const fromu = `${k}/postlogin?_timeStamp=${timeStamp}${from ? `&from=${from}` : ''}${
        needQualify ? `&needQualify=${needQualify}` : ''
    }${ambassadorId ? `&ambassadorId=${ambassadorId}` : ''}&redirect=${redirectUrl}`;
    const registerUcLink = getRegisterUcLink(timeStamp);

    return {
        staticPage,
        fromu,
        fromUrl,
        registerUcLink,
        redirectUrl,
        subuserLoginLink,
        // 将后端模版渲染的error字段展示到页面中
        // let error = '${error}';
        // 此处不好判断，因为如果用 error 会被模版替换掉，所以就用首字母是不是美元符号来判断
        // 会造成的问题是：如果错误信息是以美元符号开头的话，那么就不会展示
        error: error?.[0] === '$' ? '' : error,
        cookieDomain,
    };
}

// 根据cookie中的baiduid，区分用户做ABtest，
// 如果尾号为0-7为A类用户，如果尾号为8-f为B类用户，如果baiduid不存在，默认返回A类用户
// baiduid cookie value 示例: CF96DF2439DB3D1B9DA8937C993CBA53:FG=1
export function getABTestUserType() {
    const baiduid = Cookies.get('BAIDUID')?.toLocaleLowerCase();
    if (baiduid) {
        const last = baiduid.split(':')[0].slice(-1);
        return last >= '0' && last <= '7' ? ABTestUserType.A : ABTestUserType.B;
    }
    return ABTestUserType.A;
}

export function initMonitor() {
    monitor.init({
        api: getEnv() === 'SANDBOX' ? 'https://cloudtest.baidu.com/img/bh.gif' : 'https://cloud.baidu.com/img/bh.gif',
    });
}
